export { default as ModalProvider } from './GlobalModalProvider';

export { Consumer as ModalConsumer, default as ModalContext } from './Modal.context';
